/* eslint-disable */
export const generatedEnvironment = {
    "release": "9a9aeb1194"
};
